"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.RADIUS_UNITS = void 0;

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _DataStore = _interopRequireWildcard(require("../KESI2/Stores/DataStore2"));

var LAST_GEOLOCATION = null;
var DEFAULT_OPTIONS = {
  timeout: 250
}; // should be quick if the user has it turned on, if we wait too long it's bad

var RADIUS_UNITS = {
  METER: 'm',
  KILOMETER: 'km'
};
exports.RADIUS_UNITS = RADIUS_UNITS;

function getDistanceFromLatLonInKm(lat1, lng1, lat2, lng2) {
  var R = 6371; // Radius of the earth in km

  var dLat = deg2rad(lat2 - lat1); // deg2rad below

  var dLon = deg2rad(lng2 - lng1);
  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)); // Distance in m

  return R * c * 1000;
}

function deg2rad(deg) {
  return deg * (Math.PI / 180);
}

function cloneAsObject(obj) {
  if (obj === null || !(obj instanceof Object)) {
    return obj;
  }

  var temp = obj instanceof Array ? [] : {};

  for (var key in obj) {
    // noinspection JSUnfilteredForInLoop
    temp[key] = cloneAsObject(obj[key]);
  }

  return temp;
}

function normalizeGeolocation(geolocation) {
  if (typeof geolocation === 'string') {
    var parts = geolocation.split(',');

    if (parts.length >= 2) {
      return {
        lat: parts[0],
        lng: parts[1],
        accuracy: 0 // meters

      };
    }
  } else if (geolocation.coords && geolocation.coords.latitude && geolocation.coords.longitude) {
    return {
      lat: geolocation.coords.latitude,
      lng: geolocation.coords.longitude,
      accuracy: geolocation.coords.accuracy || 0
    };
  }

  return null;
}

var GEOLOCATION_WATCH_IDS = {};

var GeolocationHelper = /*#__PURE__*/function () {
  function GeolocationHelper() {
    (0, _classCallCheck2["default"])(this, GeolocationHelper);
  }

  (0, _createClass2["default"])(GeolocationHelper, null, [{
    key: "getCurrentPosition",

    /**
     * Request the current position from OS and returns once the data is available
     *
     * Options as they are in plain javascript
     * @param options
     */
    value: function () {
      var _getCurrentPosition = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var options,
            _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 0 && _args[0] !== undefined ? _args[0] : DEFAULT_OPTIONS;
                return _context.abrupt("return", new _promise["default"](function (resolve, reject) {
                  window.navigator.geolocation.getCurrentPosition(GeolocationHelper._getOnSuccess(resolve), GeolocationHelper._getOnError(reject), options);
                }));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getCurrentPosition() {
        return _getCurrentPosition.apply(this, arguments);
      }

      return getCurrentPosition;
    }()
    /**
     * Returns the last known position or null
     */

  }, {
    key: "getCurrentPositionImmediately",
    value: function getCurrentPositionImmediately() {
      if (!LAST_GEOLOCATION) {
        LAST_GEOLOCATION = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.GEOLOCATION);
      }

      return LAST_GEOLOCATION;
    }
  }, {
    key: "watchGeolocation",
    value: function () {
      var _watchGeolocation = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(id, options) {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // to make sure we are having a current position, not really sure it is necessary
                GeolocationHelper.getCurrentPosition();
                return _context2.abrupt("return", new _promise["default"](function (resolve, reject) {
                  GEOLOCATION_WATCH_IDS[id] = window.navigator.geolocation.watchPosition(GeolocationHelper._getOnSuccess(resolve), GeolocationHelper._getOnError(reject), options);
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function watchGeolocation(_x, _x2) {
        return _watchGeolocation.apply(this, arguments);
      }

      return watchGeolocation;
    }()
  }, {
    key: "clearWatchGeolocation",
    value: function () {
      var _clearWatchGeolocation = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(id) {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", new _promise["default"](function (resolve, reject) {
                  window.navigator.geolocation.clearWatch(GEOLOCATION_WATCH_IDS[id]);
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function clearWatchGeolocation(_x3) {
        return _clearWatchGeolocation.apply(this, arguments);
      }

      return clearWatchGeolocation;
    }()
    /**
     * Checks if a given point is in range of another one. Both geolocation1 and geolocation2 accept two different formats:
     *
     *    Format 1: comma separated string
     *              52.4549817,13.320678
     *
     *    Format 2: object as used in Javascripts getCurrentPosition()
     *              {
     *                "coords": {
     *                  "latitude": 52.455162800000004,
     *                  "longitude": 13.3227099,
     *                  "altitude": null,
     *                  "accuracy": 54,       // in meter
     *                  "altitudeAccuracy": null,
     *                  "heading": null,
     *                  "speed": null
     *                },
     *                "timestamp": 1520591071303
     *              }
     *
     * If Format 2 is given, the accuracy value is added to the given radius value
     *
     * @param geolocation1
     * @param geolocation2
     * @param radiusInMeters
     */

  }, {
    key: "isInRadius",
    value: function isInRadius(geolocation1, geolocation2, radiusInMeters) {
      var location1 = normalizeGeolocation(geolocation1);
      var location2 = normalizeGeolocation(geolocation2);
      var distance = getDistanceFromLatLonInKm(location1.lat, location1.lng, location2.lat, location2.lng);
      console.log('isInRadius', geolocation1, geolocation2, radiusInMeters, distance, radiusInMeters + location1.accuracy + location2.accuracy);
      return distance <= radiusInMeters + location1.accuracy + location2.accuracy;
    }
  }]);
  return GeolocationHelper;
}();

(0, _defineProperty2["default"])(GeolocationHelper, "_getOnSuccess", function (resolve) {
  return function (geolocation) {
    var objectifiedGeolocation = cloneAsObject(geolocation); // added additional check, otherwise android will rerender every 5 seconds

    if (objectifiedGeolocation && LAST_GEOLOCATION && (0, _stringify["default"])(objectifiedGeolocation.coords) === (0, _stringify["default"])(LAST_GEOLOCATION.coords)) {
      console.log('received and last geolocation are the same!');
      return;
    } // fire and forget, no need to wait for promise


    _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.GEOLOCATION, objectifiedGeolocation); // it's cheaper to have a local copy for further access


    LAST_GEOLOCATION = objectifiedGeolocation;

    if (resolve) {
      resolve(objectifiedGeolocation);
    }
  };
});
(0, _defineProperty2["default"])(GeolocationHelper, "_getOnError", function (reject) {
  return function (error) {
    console.error('error getting or watching geolocation', error);

    if (reject) {
      reject(error);
    }
  };
});
var _default = GeolocationHelper;
exports["default"] = _default;